// extracted by mini-css-extract-plugin
export default {"separator":"styles_separator__18orm"};